import React from 'react';

export const parseContent = (text: string): React.ReactNode => {
  const parts = text.split(/(\*\*.*?\*\*|[\w.-]+@[\w.-]+\.\w+)/g);

  return parts.map((part, idx) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={idx}>{part.replace(/\*\*/g, '')}</strong>;
    } else if (/^[\w.-]+@[\w.-]+\.\w+$/.test(part)) {
      return (
        <a key={idx} href={`mailto:${part}`} className="custom-link">
          {part}
        </a>
      );
    } else {
      return <React.Fragment key={idx}>{part}</React.Fragment>;
    }
  });
};
